import {
  AreYouOkResponseSetDtoChannel,
  AreYouOkUpdateDtoChannel,
  OpenedUpdateDtoChannel,
} from '@server/generated/openapi/safety-check';
import { z } from 'zod';

type AreYouOkSupportedChannelValue =
  | `${AreYouOkUpdateDtoChannel}`
  | `${AreYouOkResponseSetDtoChannel}`
  | `${OpenedUpdateDtoChannel}`;

export const AreYouOkChannelEnum = {
  Push: 'push',
  Sms: 'sms',
  Email: 'email',
  Voice: 'voice',
} as const satisfies Record<string, AreYouOkSupportedChannelValue>;

export const areYouOkChannel = z.enum(Object.values(AreYouOkChannelEnum));

export type AreYouOkChannel =
  (typeof AreYouOkChannelEnum)[keyof typeof AreYouOkChannelEnum];
